/**
 * Languages supported by the FlareCode judge.
 *
 * MVP (Phases 3-4): python, javascript, typescript, cpp, java, go
 * Phase 8+: rust
 */
export const LANGUAGES = ['python', 'javascript', 'typescript', 'cpp', 'java', 'go'] as const;

export type Language = (typeof LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<Language, string> = {
  python: 'Python 3',
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  cpp: 'C++',
  java: 'Java',
  go: 'Go',
};

export const LANGUAGE_FILE_EXTENSIONS: Record<Language, string> = {
  python: 'py',
  javascript: 'js',
  typescript: 'ts',
  cpp: 'cpp',
  java: 'java',
  go: 'go',
};

/**
 * Compile step required? If false, the judge can skip the compile phase.
 */
export const LANGUAGE_NEEDS_COMPILE: Record<Language, boolean> = {
  python: false,
  javascript: false,
  typescript: true,
  cpp: true,
  java: true,
  go: true,
};

/**
 * Default wall-clock run timeout per test case (milliseconds).
 * Slow languages get more generous caps.
 */
export const LANGUAGE_DEFAULT_TIMEOUT_MS: Record<Language, number> = {
  python: 3000,
  javascript: 2000,
  typescript: 2000,
  cpp: 1000,
  java: 3000,
  go: 1500,
};

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);
}
